module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "xczx"
  }, [_c('img', {
    staticClass: "bg",
    attrs: {
      "src": require("./img/banner.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "guide_text"
  }, [_vm._v("\n            多年来，蓝海密剑主办方——东航期货，围绕国家“实施乡村振兴”战略总要求，积极响应期货行业服务实体经济号召，协同母公司东航金控，在云南沧源、双江等地，践行产业帮扶、教育帮扶、消费帮扶等，以金融力量，为当地乡村振兴打造高速引擎。\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "introduce_text"
  }, [_vm._v("\n            自2019年起，公司在沧源地区持续实施“保险+期货”项目，累计引入交易所资金836余万元，赔付近677万元，惠及农户8357户。其中，天然橡胶项目持续进行，并成功试点实施了白糖和生猪“保险+期货”项目，有效保障了农户的收益。2024年，公司带动版块内兄弟公司东航保理共同出资30万元，在班老乡实施天然橡胶“保险+期货”项目，助力当地橡胶产业发展。\n        ")]), _vm._v(" "), _c('p', {
    staticClass: "introduce_text"
  }, [_vm._v("\n            在教育帮扶方面，东航期货积极参与“爱在东航 大山梦想”公益活动，累计捐款数十万元，用于改善学校设施和教学条件。例如，修建教师学生宿舍、添置教学一体机和速印机、修建学生浴室等，有效提升了当地学校的教学水平。\n        ")]), _vm._v(" "), _c('p', {
    staticClass: "introduce_text"
  }, [_vm._v("\n            在产业帮扶方面，公司捐赠资金试点百香果种植产业，取得了丰收成果。2024年，公司继续扩大百香果种植面积，助力当地产业发展。同时，公司还积极引入期货界力量参与帮扶活动，共同助力乡村振兴。\n        ")]), _vm._v(" "), _c('p', {
    staticClass: "introduce_text"
  }, [_vm._v("\n            此外，东航期货还注重党建带团建工作，将“党建引领、团建赋能”融入乡村振兴工作，充分发挥团组织作用。通过组织开展义卖活动等方式筹集爱心捐款，为当地学校捐赠体育器材和训练服等物资，用爱帮扶助成长。\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "swiper"
  }, [_c('mt-swipe', {
    staticClass: "my-swipe",
    attrs: {
      "indicator-color": "white",
      "auto": 3000
    }
  }, [_c('mt-swipe-item', [_c('img', {
    attrs: {
      "id": "img",
      "src": require("./img/swipe_01.png"),
      "alt": ""
    }
  })]), _vm._v(" "), _c('mt-swipe-item', [_c('img', {
    attrs: {
      "id": "img",
      "src": require("./img/swipe_02.png"),
      "alt": ""
    }
  })]), _vm._v(" "), _c('mt-swipe-item', [_c('img', {
    attrs: {
      "id": "img",
      "src": require("./img/swipe_03.png"),
      "alt": ""
    }
  })]), _vm._v(" "), _c('mt-swipe-item', [_c('img', {
    attrs: {
      "id": "img",
      "src": require("./img/swipe_04.png"),
      "alt": ""
    }
  })])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "swiper_text"
  }, [_vm._v("\n            < 左右滑动查看更多 >\n        ")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "callfor_text"
  }, [_vm._v("亲爱的期货行业同仁及社会各界爱心人士，")]), _vm._v(" "), _c('div', {
    staticClass: "callfor_text text_indent"
  }, [_vm._v("\n            在这个充满希望与挑战的新时代，我们诚挚地向您发出邀请，成为“蓝海密剑乡村振兴事业伙伴”！\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "callfor_text text_indent"
  }, [_vm._v("\n            让我们携手并进，将目光投向那片孕育无限可能的乡村大地。通过产业帮扶，我们赋能农村，激活经济新活力；通过教育帮扶，我们点亮智慧之光，培育未来之星；通过消费帮扶，我们搭建桥梁，让每一份支持都化作乡村发展的动力源泉。\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "callfor_text text_indent"
  }, [_vm._v("\n            您的每一分参与，都是对乡村振兴最真挚的承诺；您的每一步脚印，都将深刻在助力乡村蜕变的征途上。不论您是期货界的精英，还是心系家国的热心公民，这里都有您发光发热的舞台。\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "callfor_text text_indent"
  }, [_vm._v("\n            加入我们，用实际行动诠释责任与担当，共同书写乡村振兴的壮丽诗篇。让我们并肩作战，在希望的田野上播种梦想，收获幸福，共创一个更加繁荣、和谐的美好未来！\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "callfor_text text_indent"
  }, [_vm._v("\n            立即响应，成为“蓝海密剑乡村振兴事业伙伴”，一起开启这段意义非凡的旅程吧！\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "encourage_box pd15"
  }, [_c('van-button', {
    staticClass: "openIframe_encourage",
    on: {
      "click": _vm.encourage
    }
  }, [_vm._v("\n                    觉得这个活动不错，鼓励一下\n            ")]), _vm._v(" "), _c('div', [_c('van-icon', {
    attrs: {
      "name": "good-job"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "number"
  }, [_vm._v("\n                    " + _vm._s(_vm.encourageNum) + "\n                    ")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "title_text"
  }, [_vm._v("\n            乡村振兴 以期前行\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "nav_text"
  }, [_vm._v("\n            云南特色产品公益集市\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "qcard"
  }, [_c('div', [_c('div', {
    on: {
      "click": _vm.qcord
    }
  }, [_c('img', {
    attrs: {
      "src": require("./img/dh.png"),
      "alt": ""
    }
  })]), _vm._v(" "), _vm._m(1)]), _vm._v(" "), _c('div', [_c('div', {
    on: {
      "click": _vm.previewImg
    }
  }, [_c('img', {
    attrs: {
      "src": require("./img/miniProgram.jpg"),
      "alt": ""
    }
  })]), _vm._v(" "), _vm._m(2)])]), _vm._v(" "), _c('div', {
    staticClass: "project_text"
  }, [_vm._v("\n            组委会计划助力帮扶以下项目：\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "ask_text fupin_text"
  }, [_vm._v("\n            班老乡九年一贯制中心校——\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "ask_text fupin_text"
  }, [_vm._v("\n            悬浮地板篮球场及跑道项目、采购学生课桌项目、会议室桌椅采购项目、台式机电脑采购项目等，助力当地小学改善教学条件，助力当地教育发展。\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "ask_text money_text"
  }, [_vm._v("\n            具体支持项目及金额以实际为准。\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "fupin_text pd15"
  }, [_vm._v("\n            若您想进一步助力，请留下联系方式，组委会将会联系您具体事宜。\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "openIframe_bx"
  }, [_c('van-button', {
    staticClass: "openIframe",
    on: {
      "click": _vm.openIframe
    }
  }, [_vm._v("我要进一步助力")])], 1)]), _vm._v(" "), _c('van-overlay', {
    attrs: {
      "show": _vm.showAlert
    },
    on: {
      "click": function($event) {
        _vm.showAlert = false
      }
    }
  }, [_c('div', {
    staticClass: "wrapper"
  }, [_c('img', {
    staticStyle: {
      "width": "300px",
      "height": "300px"
    },
    attrs: {
      "src": require("./img/miniProgram.jpg"),
      "alt": ""
    }
  })])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "title"
  }, [_c('img', {
    attrs: {
      "src": require("./img/title.png"),
      "alt": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._v("请直接点击上方二维码"), _c('br'), _vm._v("参与消费帮扶")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._v("请用微信\"扫一扫\"上方二维码"), _c('br'), _vm._v("参与消费帮扶")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-74dca5f4"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/xczx/index.vue
// module id = 898
// module chunks = 2